import ContactSalesStrings from './ContactSalesStrings';
var strings = ContactSalesStrings.leadForm;
export var SELECT_COMPANY_SIZE_OPTIONS = [
    {
        name: '1 - 50',
        value: '50',
    },
    {
        name: '51 - 100',
        value: '100',
    },
    {
        name: '101 - 500',
        value: '500',
    },
    {
        name: '501 - 1000',
        value: '1000',
    },
    {
        name: '1000+',
        value: '1001',
    },
];
export var FREQUENCY_OF_USE_VALUES;
(function (FREQUENCY_OF_USE_VALUES) {
    FREQUENCY_OF_USE_VALUES["RECURRING"] = "recurring";
    FREQUENCY_OF_USE_VALUES["ADHOC"] = "event-based";
})(FREQUENCY_OF_USE_VALUES || (FREQUENCY_OF_USE_VALUES = {}));
export var SELECT_FREQUENCY_OF_USE_OPTIONS = [
    {
        name: strings.frequencyOfUse.regularBasisOption(),
        value: FREQUENCY_OF_USE_VALUES.RECURRING,
    },
    {
        name: strings.frequencyOfUse.adhocBasisOption(),
        value: FREQUENCY_OF_USE_VALUES.ADHOC,
    },
];
